import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "DoubleArrowLeft"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M528.992 148.992q8.992-8 20.992-8t20.992 8.992 8.992 20.992-8.992 20.992l-312 320 312 320q8.992 8.992 8.992 21.504t-8.992 20.992-20.992 8.512-20.992-8L197.984 533.984q-8.992-10.016-8.992-22.496t8.992-21.504z m256 0q8.992-8 20.992-8t20.992 8.992 8.992 20.992-8.992 20.992l-312 320 312 320q8.992 8.992 8.992 21.504t-8.992 20.992-20.992 8.512-20.992-8L453.984 533.984q-8.992-10.016-8.992-22.496t8.992-21.504z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var doubleArrowLeft = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\double-arrow-left.vue"]]);

export { doubleArrowLeft as default };
